import React, { useEffect } from 'react'
import Home from "./Home";
import { Accordion } from "react-bootstrap";
import { useTranslation } from "react-i18next";

function SalesMaintenance () {
    const [lang] = useTranslation("language");
    useEffect (() => {
        document.body.classList.add("sidebar-open");
    })
    return (
            <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                <Accordion.Header>
                    {lang("dailySellout.maintenance")}
                </Accordion.Header>
                <Accordion.Body>
                    <div className="email-settings">
                        <h2>
                            <span>★★★  </span>
                            {lang("dailySellout.systemError")}
                            <span>  ★★★</span>
                        </h2>
                        <div className="message">{lang("dailySellout.systemErrorMessage")}</div>
                    </div>
                </Accordion.Body>
                </Accordion.Item>
            </Accordion>
    )
}

export default SalesMaintenance